'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

        $('.accordion-btn-wrapper').on('click', '.btn', function(){

            var accordionList = $(this).parent().next().find('>li');

            if($(this).hasClass('btn-expand-all')){
                accordionList.addClass('open');
                accordionList.find('section').slideDown();
            }

            if($(this).hasClass('btn-collapse-all')){
                accordionList.removeClass('open');
                accordionList.find('section').slideUp();
            }

            return false;
        });

        $('.accordion > li > a').on('click', function () {
            var self = $(this);
            var parent = self.parents('li');

            /* Close other before opening */
            //parent.siblings().removeClass('open');
            //parent.siblings().find('section').stop().slideUp();

            parent.find('section').stop().slideToggle(function () {
                parent.toggleClass('open');

                //$("html, body").animate({ scrollTop: (parent.offset().top - self.outerHeight()) + "px" }, 600);
            });

            return false;
        });


}
